import { PaymentMethod } from '@entities/payment'
import { Amount } from '@root/api/ump-ewallet'

export const getClientBaseAmount = (
  amount: Pick<Amount, 'base' | 'fee' | 'total'> | null,

  isPubg: boolean,

  isNonTopUpService: boolean,
  isTopUpWithPercentFeeService: boolean,
  paymentMethod: PaymentMethod
) => {
  if (!amount || !amount.base) return '0'

  if (isPubg || isTopUpWithPercentFeeService) {
    if (paymentMethod === PaymentMethod.CARD) {
      return amount.base
    }

    return amount.total
  }

  if (isNonTopUpService) {
    if (paymentMethod === PaymentMethod.CARD) {
      return amount.base
    }

    return Number(amount.base) + Number(amount.fee) / 2
  }

  return amount.base || ''
}
